module.exports = __webpack_public_path__ + "67db25b8e09f027b9cc80eb092c16292.svg";